/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateColorDto = {
  /**
   * Color name
   */
  name: string;
  /**
   * Color description
   */
  description?: string;
  /**
   * Source of creation
   */
  source?: CreateColorDto.source;
};
export namespace CreateColorDto {
  /**
   * Source of creation
   */
  export enum source {
    CATALOG = 'CATALOG',
    SETTINGS = 'SETTINGS',
  }
}
